/**
 * Vuikit 0.8.10
 * (c) 2018 Miljan Aleksic
 * @license MIT
**/

/* Substantial part of the code is adapted from UIkit,
  Copyright (c) 2013-2018 YOOtheme GmbH, getuikit.com */

var index = {
  inserted: function inserted (el, binding, vnode) {
    vnode.context.$nextTick(function () {
      vnode.context.$root.$el.appendChild(el);
    });
  }
}

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuikit/lib/core/v-root.js
// module id = null
// module chunks = 